import { render, staticRenderFns } from "./VInfoRow.vue?vue&type=template&id=e7271cd4&"
import script from "./VInfoRow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VInfoRow.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VInfoRow.vue?vue&type=style&index=0&id=e7271cd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports